/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { EquipmentServiceHistoryItem } from '../model/equipmentServiceHistoryItem';
import { MembershipDetail } from '../model/membershipDetail';
import { MembershipsCustomer } from '../model/membershipsCustomer';
import { MembershipsRecurringServicesSettings } from '../model/membershipsRecurringServicesSettings';
import { SetMembershipPreferredPaymentMethodRequest } from '../model/setMembershipPreferredPaymentMethodRequest';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class MembershipsApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public getEquipmentServiceHistorySummaryObservable: Array<EquipmentServiceHistoryItem> | undefined = undefined;

    /**
     * 
     * 
     * @param id 
     */
    @action
    public getEquipmentServiceHistorySummary(id: number, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<EquipmentServiceHistoryItem>> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getEquipmentServiceHistorySummary.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<EquipmentServiceHistoryItem>>(
            `${this.basePath}/api/memberships/equipmenthistory/${encodeURIComponent(String(id))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getEquipmentServiceHistorySummaryObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getMembershipDetailObservable: MembershipDetail | undefined = undefined;

    /**
     * 
     * 
     * @param id 
     */
    @action
    public getMembershipDetail(id: number, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<MembershipDetail> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getMembershipDetail.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<MembershipDetail>(
            `${this.basePath}/api/memberships/${encodeURIComponent(String(id))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getMembershipDetailObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getMembershipsObservable: Array<MembershipsCustomer> | undefined = undefined;

    /**
     * 
     * 
          */
    @action
    public getMemberships(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<MembershipsCustomer>> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<MembershipsCustomer>>(
            `${this.basePath}/api/memberships`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getMembershipsObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getRecurringServiceSettingsObservable: MembershipsRecurringServicesSettings | undefined = undefined;

    /**
     * 
     * 
          */
    @action
    public getRecurringServiceSettings(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<MembershipsRecurringServicesSettings> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<MembershipsRecurringServicesSettings>(
            `${this.basePath}/api/memberships/settings/recurringservices`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getRecurringServiceSettingsObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public setMembershipPreferredPaymentMethodObservable: any = undefined;

    /**
     * 
     * 
     * @param id 
* @param body 
     */
    @action
    public setMembershipPreferredPaymentMethod(id: number, body?: SetMembershipPreferredPaymentMethodRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling setMembershipPreferredPaymentMethod.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.patch<any>(
            `${this.basePath}/api/memberships/${encodeURIComponent(String(id))}/paymentmethod`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.setMembershipPreferredPaymentMethodObservable = response.data);
            }
            return response;
        });
    }

}
